import React from 'react';
import PropTypes from 'prop-types';

import OnboardingLayout from '../../../OnboardingLayout';

const propTypes = {
  children: PropTypes.node.isRequired,
};

const PhotoSearchCheckoutLayout = ({ children }) => {
  return <OnboardingLayout>{children}</OnboardingLayout>;
};

PhotoSearchCheckoutLayout.propTypes = propTypes;

export default PhotoSearchCheckoutLayout;
